import { Heading, Text } from "@/design-system";
import { cn } from "@/utils";
import { PageSection } from "@/pages/landingPage/components/pageSection";
import type { SeoImage, SourcedFact } from "../types";
import { SeoPicture } from "./seoPicture";
import { SourcedMetricGrid } from "./sourcedMetricGrid";

type SegmentPainProps = {
  id: string;
  title: string;
  lead: string;
  facts: SourcedFact[];
  image?: SeoImage;
};

export const SegmentPain = ({
  id,
  title,
  lead,
  facts,
  image,
}: SegmentPainProps) => (
  <PageSection
    labelledBy={`${id}-title`}
    className={cn(
      "grid grid-cols-1 items-center gap-10 lg:gap-12",
      image && "lg:grid-cols-2"
    )}
  >
    <div className="flex flex-col gap-6">
      <Heading level={2} id={`${id}-title`}>
        {title}
      </Heading>
      <Text size="lead" tone="muted" className="max-w-2xl">
        {lead}
      </Text>
      {/* Com imagem ao lado, a coluna é estreita: um número por linha. */}
      <SourcedMetricGrid
        facts={facts}
        className={cn(image && "lg:grid-cols-1")}
      />
    </div>
    {image ? (
      <div className="rounded-ds-xl overflow-hidden">
        <SeoPicture
          image={image}
          sizes="(min-width: 1024px) 560px, calc(100vw - 32px)"
        />
      </div>
    ) : null}
  </PageSection>
);
